import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Page from "../../components/Page/Page.Component";
import { Button } from "@material-ui/core";
import { Toolbar, Grid, Card, CardContent } from "@mui/material";
import {
  SiteVisitAssessmentService,
  MasService,
  AlertService,
  UtilsService,
} from "src/services";
import { useHistory, useLocation } from "react-router";
import {
  EvaVersionCard,
  FilesUploader,
  PageLoading,
  PopupSearchVendor,
  VendorDetailCard,
} from "src/components";
import AssessmentAuditorDetail from "./AssessmentAuditorDetail";
import SiteVisitQuestionSet from "./SiteVisitQuestionSet";
import ScoreMethodSiteVisitCard from "./ScoreMethodSiteVisitCard";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "3%",
    marginRight: "3%",
    marginTop: "2%",
  },
  toolbar: {
    minHeight: "35px !important",
  },
  flexGrow: {
    flexGrow: 1,
  },
  title: {
    color: "#064878",
    fontWeight: "bold",
  },
  btnSaveDaft: {
    color: "#fff ",
    backgroundColor: "#FF8C06 ",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2),
    "&:hover": {
      color: "#FE744C",
      backgroundColor: "#fddad0 ",
    },
  },
  btnSubmit: {
    color: "#fff ",
    backgroundColor: "#04B22B ",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2),
    "&:hover": {
      color: "#04B22B",
      backgroundColor: "#91ffaa ",
    },
  },
  btnCancel: {
    color: "#fff ",
    backgroundColor: "#EB5C52 ",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2),
    "&:hover": {
      color: "#EB5C52",
      backgroundColor: "#ffb7b2 ",
    },
  },
  btnBack: {
    color: "#fff ",
    backgroundColor: "#A7A5A5 ",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2),
    "&:hover": {
      color: "#A7A5A5",
      backgroundColor: "#d7d7d7 ",
    },
  },
  btnDownload: {
    color: "#fff ",
    backgroundColor: "#1E77B8",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2),
    "&:hover": {
      color: "#A7A5A5",
      backgroundColor: "#1E77B8",
    },
  },
}));

function SiteVisitAssessmentScreen() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [params, setParams] = useState({});
  const [isViewMode, setIsViewMode] = useState(false);
  const [evaVersionData, setEvaVersionData] = useState({});
  const [versionList, setVersionList] = useState([]);
  const [assessmentAuditorDetail, setAssessmentAuditorDetail] = useState({});
  const [onLoading, setOnLoading] = useState(false);
  const [vendorDetail, setVendorDetail] = useState({});
  const [vendorScore, setVendorScore] = useState({});
  const [companyList, setCompanyList] = useState([]);
  const [evaForm, setEvaForm] = useState({});
  const [siteVisitQuestionSet, setSiteVisitQuestionSet] = useState({});
  const [showPrintButton, setShowPrintButton] = useState(false);
  const [scoreMethodDataTH, setScoreMethodDataTH] = useState("");
  const [scoreMethodDataEN, setScoreMethodDataEN] = useState("");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (location.state) {
      setParams(location.state);
      setIsViewMode(!!location.state.isViewMode);
      getAssessment({
        vendorRegisID: location.state.vendor,
        mainVersionID: location.state.main,
        subVersionID: location.state.sub,
        vatRegistrationNo: 0,
      });
    }
  }, [location]);

  useEffect(() => {
    MasService.GetCompany().then((resp) => {
      const data = resp.data || [];
      setCompanyList(data);
    });
    MasService.GetEvaVersion().then((resp) => {
      const data = resp.data || [];
      setVersionList(data);
    });
    SiteVisitAssessmentService.GetMasConfigByConfigCode('05').then((resp) => {
      const data = resp || [];
      setScoreMethodDataTH(data.configValue);
    });
    SiteVisitAssessmentService.GetMasConfigByConfigCode('06').then((resp) => {
      const data = resp || [];
      setScoreMethodDataEN(data.configValue);
    });
  }, []);

  const getAssessment = (request) => {
    setOnLoading(true);
    SiteVisitAssessmentService.GetAssessment(request)
      .then((resp) => {
        const data = resp.data || {};
        if (["A", "I", "R"].includes(data.statusCode)) {
          setIsViewMode(true);
        }
        setEvaForm(data);

        setEvaVersionData({
          version: {
            mainVersionID: data.mainVersionID,
            versionName: data.versionName,
            subVersionID: data.subVersionID,
          },
          versionName: data.versionName,
          esgFormName: data.esgFormNameTH,
          esgFormDetail: data.esgFormDetailTH,
        });

        setVendorScore({
          resultCode: data.resultCode,
          averageScore: data.averageScore,
          fullScore: data.fullScore,
        });

        setSiteVisitQuestionSet({
          weight: data.weight,
          totalScore: data.totalScore,
          sections: data.sections,
          isWeightChecked:
            !!((data && data.sections) || []).find(
              (section) => section.weight
            ) || data.weight,
          selfAssessmentScore: data.selfAssessmentScore,
        });
        setAssessmentAuditorDetail({
          siteVisitDate: data.siteVisitDate,
          ownerCompESGFrom: data.ownerCompESGFrom,
          is3RDChecked: !!data.siteVisitByThirdparty,
          siteVisitBy3RD: data.siteVisitByThirdparty,
          isOwnerCompChecked: !!data.siteVisitByOwnerComp,
          siteVisitByOwnerComp: data.siteVisitByOwnerComp,
        });
        var checkInvalid = data.sections.filter(x => x.isValid === false);
        if (checkInvalid.length === 0) {
          setShowPrintButton(true);
        }
      })
      .catch(() => setOnLoading(false))
      .then(() => setOnLoading(false));
  };

  const handleSubmit = (statusCode) => {
    setOnLoading(true);

    if (statusCode === "R" && !params.vendor) {
      handleGoBack();
      return;
    }

    if (!vendorDetail.vatRegistrationNo) {
      AlertService.warning({ html: t("Confirm.validateVendor") });
      setOnLoading(false);
      return;
    }

    if (
      statusCode === "A" &&
      !!siteVisitQuestionSet.isWeightChecked && siteVisitQuestionSet.sections.filter((section) => section.weight).length > 0 &&
      siteVisitQuestionSet.sections.filter((section) => section.weight).length !== siteVisitQuestionSet.sections.length
    ) {
      AlertService.warning({
        html: t("Confirm.validateWeight"),
      });
      setOnLoading(false);
      return;
    }

    if (
      statusCode === "A" &&
      siteVisitQuestionSet.sections.filter((section) => section.totalScore).length > 0 &&
      siteVisitQuestionSet.sections.filter((section) => section.totalScore).length !== siteVisitQuestionSet.sections.length
    ) {
      AlertService.warning({
        html: t("Confirm.validateScore"),
      });
      setOnLoading(false);
      return;
    }

    if (
      statusCode === "A" &&
      (!assessmentAuditorDetail.is3RDChecked && !assessmentAuditorDetail.isOwnerCompChecked)
    ) {
      AlertService.warning({
        html: t("Confirm.validateIdentify"),
      });
      setOnLoading(false);
      return;
    }

    const savefiles = [];
    const filePath = `${vendorDetail.vatRegistrationNo}/${evaForm.mainVersionID}${evaForm.subVersionID}/`;

    const requestData = {
      vatRegistrationNo: vendorDetail.vatRegistrationNo,
      vendorRegisID: params.vendor,
      mainVersionID: evaVersionData.version.mainVersionID,
      subVersionID: evaVersionData.version.subVersionID,
      esgType: "2",
      statusCode: statusCode,
      siteVisitDate: assessmentAuditorDetail.siteVisitDate,
      ownerCompESGFrom: assessmentAuditorDetail.ownerCompESGFrom,
      siteVisitByThirdparty: assessmentAuditorDetail.is3RDChecked
        ? assessmentAuditorDetail.siteVisitBy3RD
        : "",
      siteVisitByOwnerComp: assessmentAuditorDetail.isOwnerCompChecked
        ? assessmentAuditorDetail.siteVisitByOwnerComp
        : "",
      isWeightChecked: siteVisitQuestionSet.isWeightChecked || false,
      totalScore: siteVisitQuestionSet.totalScore || 0,
      weight: siteVisitQuestionSet.weight || 0,
    };

    requestData.visitSiteFiles = (evaForm.visitSiteFiles || []).map((file) => {
      file.path = filePath;
      if (file.file) {
        savefiles.push(file);
      }
      return file;
    });
    requestData.actionPlanFiles = (evaForm.actionPlanFiles || []).map(
      (file) => {
        file.path = filePath;
        if (file.file) {
          savefiles.push(file);
        }
        return file;
      }
    );

    requestData.sections = siteVisitQuestionSet.sections.map((section) => {
      return {
        sectionID: section.sectionID,
        weight: !!siteVisitQuestionSet.isWeightChecked ? section.weight : 0,
        totalScore: section.totalScore || 0,
      };
    });
    savefiles.forEach((file) => {
      const reader = new FileReader();
      const fileByteArray = [];
      reader.readAsArrayBuffer(file.file);
      reader.onloadend = (evt) => {
        if (evt.target.readyState === FileReader.DONE) {
          const arrayBuffer = evt.target.result,
            array = new Uint8Array(arrayBuffer);
          for (const a of array) {
            fileByteArray.push(a);
          }
        }
        if (fileByteArray.length > 0) {
          const requestSaveFile = {
            FileName: file.name,
            FilePath: file.path,
            bytesFile: fileByteArray,
          };
          UtilsService.SaveFile(requestSaveFile).catch(() => { });
        }
      };
    });

    SiteVisitAssessmentService.SaveAssessment(requestData)
      .then((resp) => {
        const data = resp.data || {};
        if (resp.code !== 200) {
          AlertService.error({
            html: "ไม่สามารถทำรายการได้ กรุณาลองใหม่อีกครั้ง",
          });
          return;
        }
        if (data.statusCode === "R") {
          handleGoBack();
          return;
        }
        if (!data.resultCode) {
          if (+data.vendorRegisID !== +params.vendor) {
            history.push({
              pathname: "/SiteVisitAssessment",
              state: {
                vendor: data.vendorRegisID,
                main: params.main,
                sub: params.sub,
                type: params.type,
              },
            });
            return;
          }
          getAssessment({
            vendorRegisID: data.vendorRegisID,
            mainVersionID: requestData.mainVersionID,
            subVersionID: requestData.subVersionID,
            vatRegistrationNo: requestData.vatRegistrationNo,
          });
          return;
        }
        if (data.resultCode === "P") {
          AlertService.success2({
            html:
              t("Confirm.siteVisitScorePass") +
              parseFloat(data.averageScore || 0).toFixed(2),
          }, i18n.language).then(() => {
            if (data.statusCode === "D") {
              if (+data.vendorRegisID !== +params.vendor) {
                history.push({
                  pathname: "/SiteVisitAssessment",
                  state: {
                    vendor: data.vendorRegisID,
                    main: params.main,
                    sub: params.sub,
                    type: params.type,
                  },
                });
                return;
              }
              getAssessment({
                vendorRegisID: data.vendorRegisID,
                mainVersionID: requestData.mainVersionID,
                subVersionID: requestData.subVersionID,
                vatRegistrationNo: requestData.vatRegistrationNo,
              });
              return;
            }
            handleGoBack();
          });
          return;
        }
        AlertService.warning2({
          html:
            t("Confirm.siteVisitScoreFail") +
            parseFloat(data.averageScore || 0).toFixed(2) +
            t("Confirm.siteVisitScoreFailNote"),
        }, i18n.language).then(() => {
          if (data.statusCode === "D") {
            if (+data.vendorRegisID !== +params.vendor) {
              history.push({
                pathname: "/SiteVisitAssessment",
                state: {
                  vendor: data.vendorRegisID,
                  main: params.main,
                  sub: params.sub,
                  type: params.type,
                },
              });
              return;
            }
            getAssessment({
              vendorRegisID: data.vendorRegisID,
              mainVersionID: requestData.mainVersionID,
              subVersionID: requestData.subVersionID,
              vatRegistrationNo: requestData.vatRegistrationNo,
            });
            return;
          }
          handleGoBack();
        });
      })
      .catch(() => {
        AlertService.error({
          html: "ไม่สามารถทำรายการได้ กรุณาลองใหม่อีกครั้ง",
        });
        setOnLoading(false);
      })
      .then(() => setOnLoading(false));
  };

  const handleGoBack = () => {
    if (params.type === 'InquiryAll') {
      history.push('/EvaluationResult/InquiryAll');
      return;
    }
    history.push('/EvaluationSiteByPtt/SiteVisit');
  };

  const handleDownload = () => {
    window.open("/Evaluation/DownloadPDF/" + params.vendor, "_blank");
  };

  const handleSearchVendor = (value) => {
    setVendorDetail({ ...vendorDetail, ...value });
    getAssessment({
      vendorRegisID: params.vendor,
      mainVersionID: evaVersionData.version.mainVersionID,
      subVersionID: evaVersionData.version.subVersionID,
      vatRegistrationNo: value.vatRegistrationNo || 0,
    });
  };

  const handleEvaVersionComplete = (result) => {
    setEvaVersionData(result);
    getAssessment({
      vendorRegisID: params.vendor,
      mainVersionID: result.version.mainVersionID,
      subVersionID: result.version.subVersionID,
      vatRegistrationNo: vendorDetail.vatRegistrationNo || 0,
    });
  };
  const handleAuditorDetailComplete = (result) => {
    setAssessmentAuditorDetail(result);
  };
  const handleSiteVisitQuestionSetComplete = (result) => {
    setSiteVisitQuestionSet(result);
  };

  const handleVisitSiteFileChange = (files) => {
    evaForm.visitSiteFiles = files;
    setEvaForm(evaForm);
  };

  const handleActionPlanFileChange = (files) => {
    evaForm.actionPlanFiles = files;
    setEvaForm(evaForm);
  };

  return (
    <Page className={classes.root} title="SiteVisitAssessment">
      <PageLoading open={onLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Toolbar className={classes.toolbar}>
            <span className={classes.title}>
              {t("vendorSite.headerLabel1")}
            </span>
          </Toolbar>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Toolbar className={classes.toolbar}>
            <PopupSearchVendor
              isViewMode={
                isViewMode ||
                (evaForm.statusCode === "D" && +params.vendor !== 0)
              }
              onClose={handleSearchVendor}
              selectedValue={evaForm.vatRegistrationNo}
            />
            <div className={classes.flexGrow} />
            <div>
              <Button
                style={{ display: isViewMode ? "none" : undefined }}
                className={classes.btnSaveDaft}
                onClick={() => {
                  AlertService.question2({
                    html: t("Confirm.saveDraft")
                  },t("Confirm.confirmText"),t("Confirm.cancelText")).then((value) => value.isConfirmed && handleSubmit("D"));
                }}
              >
                {t("VendorSelf.btnSaveDraft")}
              </Button>
              <Button
                style={{ display: isViewMode ? "none" : undefined }}
                className={classes.btnSubmit}
                onClick={() => {
                  AlertService.question2({
                    html: t("Confirm.save"),
                  },t("Confirm.confirmText"),t("Confirm.cancelText")).then((value) => value.isConfirmed && handleSubmit("A"));
                }}
              >
                {t("VendorSelf.btnConfirm")}
              </Button>
              <Button
                style={{ display: isViewMode ? "none" : undefined }}
                className={classes.btnCancel}
                onClick={() => {
                  AlertService.question2({
                    html: t("Confirm.cancel"),
                  },t("Confirm.confirmText"),t("Confirm.cancelText")).then((value) => value.isConfirmed && handleSubmit("R"));
                }}
              >
                {t("VendorSelf.btnCancel")}
              </Button>
              <Button
                style={{ display: showPrintButton ? undefined : "none" }}
                className={classes.btnDownload} onClick={handleDownload}>
                {t("VendorSelf.btnPrintReport")}
              </Button>
              <Button className={classes.btnBack} onClick={handleGoBack}>
              {t("VendorSelf.btnBack")}
              </Button>
            </div>
          </Toolbar>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <VendorDetailCard
            data={{ ...vendorDetail, ...vendorScore }}
            isViewMode={isViewMode}
            type={2}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <EvaVersionCard
            data={evaVersionData}
            isViewMode={
              isViewMode ||
              (evaForm.statusCode === "D" && +params.vendor !== 0)
            }
            // autoCompleteData={versionList}
            autoCompleteData={[]}
            onComplete={handleEvaVersionComplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <AssessmentAuditorDetail
            isViewMode={isViewMode}
            data={assessmentAuditorDetail}
            autoCompleteData={companyList}
            onComplete={handleAuditorDetailComplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <ScoreMethodSiteVisitCard data={i18n.language === "th" ? scoreMethodDataTH : scoreMethodDataEN} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <SiteVisitQuestionSet
            data={siteVisitQuestionSet}
            isViewMode={isViewMode}
            onComplete={handleSiteVisitQuestionSetComplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Card variant="outlined">
            <CardContent>
              <b>{t("vendorSite.otherFileOutOfQuestion")}</b>
              <FilesUploader
                isViewMode={isViewMode}
                data={evaForm.visitSiteFiles}
                accept=".jpg, .jpeg, .png, .pdf, .xls, .xlsx, .doc, .docx"
                maximumFileSize={10485760}
                onComplete={(files) => {
                  handleVisitSiteFileChange(files);
                }}
              />
              <br />
              <b>{t("vendorSite.docs")}</b>
              <FilesUploader
                isViewMode={isViewMode}
                data={evaForm.actionPlanFiles}
                accept=".jpg, .jpeg, .png, .pdf, .xls, .xlsx, .doc, .docx"
                maximumFileSize={10485760}
                onComplete={(files) => {
                  handleActionPlanFileChange(files);
                }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Page>
  );
}

export default SiteVisitAssessmentScreen;
